<script setup>
import { ref, defineExpose, inject, watch, computed, defineEmits } from "vue"
import i18n from "@/i18n"
import { uploadFile } from "@/service";
import heatImg from '@/assets/img/thermal_comfort.png';
import customFieldCom from "./../common/customField.vue";
import { useRoute } from "vue-router";
import SwiperTool from "@/components/swiperTool.vue";
import {
    getLangValue, //getExcelData 
} from "@/utils/common"; //获取后端语言
const route = useRoute()
// 注入通知函数
const openAlert = inject('openAlert')
const detailInfo = inject('detailInfo')
const showType = inject('showType')
const isCheckForm = ref(false)
const tabList = inject('tabList')
const current_tab = inject('current_tab')
const emits = defineEmits(['clearComfortInfoFtt'])
//热湿舒适度
const heatList = ref([
    {
        fileList: [],
        id: 'heatFiledUpload',
        accept: '.dat', // 接受的类型
        fileMaxSize: 1024 * 1024 * 50, //50M
        info: `${getLangValue('upload.typeExcel')}${getLangValue('upload.limit')}50M`,
    }
])
// 自定义的字段list 包含有上传框的
const customFieldsList = ref([])
// 自定义table信息list
const customTableList = ref([]
)
const isInit = ref(true)
//自定义字段list 底部
const customFieldsList1 = ref([
    {
        name: '', // 文本名称
        fieldsList: [
            {
                name: '字段1', //字段名称
                unit: '', //字段单位
                value: '',
            },
            {
                name: '字段2', //字段名称
                unit: '', //字段单位
                value: '',
            },
            {
                name: '字段3', //字段名称
                unit: '', //字段单位
                value: '',
            },
        ],
        showUpload: false,
        showDelete: true,
    },
    {
        name: '', // 文本名称
        fieldsList: [
            {
                name: '字段1', //字段名称
                unit: '', //字段单位
                value: '',
            },
            {
                name: '字段2', //字段名称
                unit: '', //字段单位
                value: '',
            },
            {
                name: '字段3', //字段名称
                unit: '', //字段单位
                value: '',
            },
        ],
        showUpload: true,
        showDelete: true,
        id: 'comfortcustomFiledUpload',
        accept: '', // 接受的类型
        fileMaxSize: 1024 * 1024 * 200, //200M
        fileList: [],
    }
])

//方法
/**文件上传部分 */
// 自定义上传框的字段校验
const checkFileUpload = () => {
    isCheckForm.value = true
    let checkRes = true;
    for (let k in customFieldsList.value) {
        const { fieldsList } = customFieldsList.value[k]
        for (let kk in fieldsList) {
            let { required, value } = fieldsList[kk]
            if (required && !value) {
                checkRes = false;
                break;
            }
        }
    }
    return checkRes
}

// 底部自定义字段信息字段校验
const checkFileUpload1 = () => {
    isCheckForm.value = true
    let checkRes = true;
    for (let k in customFieldsList1.value) {
        const { fieldsList } = customFieldsList1.value[k]
        for (let kk in fieldsList) {
            let { required, value } = fieldsList[kk]
            if (required && !value) {
                checkRes = false;
                break;
            }
        }
    }
    return checkRes
}

const checkFile = (index, file) => {
    // 上传文件校验
    const { fileList, accept } = heatList.value[index]
    let name = /^device\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
    let suffix = name.substring(name.lastIndexOf(".")).toLowerCase();
    const acceptTypes = accept.toLowerCase().split(',').filter(Boolean)
    // 判断是否属于指定的类型
    if (!acceptTypes.includes(suffix)) {
        openAlert(
            {
                variant: "danger",
                content: getLangValue("upload.notCorrectType"),
            },
        );
        return false;
    }
    // 判断是否是同一个文件
    let arr = fileList.filter(item => item.filname == name)
    if (arr.length > 0) {
        openAlert(
            {
                variant: "danger",
                content: getLangValue("upload.notSameFile"),
            },
        );
        return false;
    }
    return true;
}
const handleFile = (index, dropzoneFile) => {
    const input = document.getElementById(heatList.value[index].id)
    let fileMaxSize = heatList.value[index].fileMaxSize
    if (!dropzoneFile) return;
    if (dropzoneFile.size > fileMaxSize) {
        openAlert(
            {
                variant: "danger",
                content: getLangValue("upload.limit"),
            },
            false
        );
        if (input) input.value = "";
        return;
    }
    if (!checkFile(index, dropzoneFile)) {
        if (input) input.value = "";
        return;
    }
    uploadFile(dropzoneFile)
        .then((res) => {
            heatList.value[index].fileList.push(res.data.payload);
            if (input) input.value = ''
            // 获取信息
            // getHeatData(dropzoneFile)
        })
        .catch((e) => {
            console.log(e);
        });

}

const selectedFile = (index) => {
    const input = document.getElementById(heatList.value[index].id)
    handleFile(index, input?.files[0])
}

// const getHeatData = (file) => {
//     // 获取dat文件信息
//     const dat_data = getExcelData(file)
//     console.log(dat_data);
// }

const drop = (e, index) => {
    handleFile(index, e.dataTransfer.files[0])
}
const deleteFile = (i, _type, index) => {
    heatList.value[index].fileList.splice(i, 1);
}
const filterImglist = (valList, imageInfo) => {
    // 筛选图片
    if (valList && valList.length && Object.keys(valList).length) {
        const fileList = valList.map(item => {
            return imageInfo[item]
        })
        return fileList
    }
    return []
}

// 监听detailInfo 组装数据
watch(detailInfo, (val) => {
    const { comfort_info } = val
    // console.log('ci', comfort_info);
    //设置热湿舒适度
    const heList = comfort_info.children.filter(item => item.show && item.key == "comfort_info_humidity_heat_comfort")
    if (heList.length) {
        heatList.value = [{
            fileList: [],
            showDelete: true,
            id: 'heatFiledUpload',
            accept: '.dat', // 接受的类型
            fileMaxSize: 1024 * 1024 * 50, //50M
            info: `${getLangValue('upload.typeExcel')}${getLangValue('upload.limit')}50M`,
            name: heList[0].name,
            name_en: heList[0].name_en
            // value: heList[0].value
        }]
        if (heList[0].value && heList[0].value.length) {
            // let ids = heList[0].value.join(',')
            // getFileUrl({ attachments: ids }).then(res => {
            //     res.payload.map(item => {
            //         item.filename = item.name
            //     })
            //     heatList.value[0].fileList = res.payload
            // })
            heatList.value[0].fileList = filterImglist(heList[0].value, val.imageInfo)
        }
    } else {
        heatList.value = []
        showType.value = false;
    }
    //自定义字段list  uukey存在的那五个 
    const cfList = comfort_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项") && item.extra.uukey)
    // console.log(comfort_info.children)
    if (cfList.length) {
        customFieldsList.value = cfList.map(item => {
            let m = {
                name: item.name,
                name_en: item.name_en,
                fieldsList: [],
                uukey: item.extra.uukey,
                key: item.key
            }
            if (item.extra.myKey == '文本项') {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
                m.hideCopy = item.extra.hideCopy
                m.showName = item.extra.showName
                m.showTable = item.extra.showTable ? true : false,
                    m.tabList = item.extra.tabList ? item.extra.tabList : []
            } else {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
                m.hideCopy = item.extra.hideCopy
                m.showName = item.extra.showName
                m.info = item.extra.uukey == 'FTT' || item.key == 'water' ? `${getLangValue('upload.typeExcel')}${getLangValue('upload.limit')}50M` : `${getLangValue('upload.limit')}50M`
                m.id = item.extra.id
                if (item.extra.uukey == 'FTT' || item.key == 'water') {
                    m.accept = '.xlsx, .xls'
                } else {
                    m.accept = ''
                }
                m.fileMaxSize = 1024 * 1024 * 50
                m.fileList = filterImglist(item.value, val.imageInfo)
                m.value = item.value
                m.showTable = item.extra.showTable ? true : false,
                    m.tabList = item.extra.tabList ? item.extra.tabList : []
            }
            if (item.children)
                m.fieldsList = item.children.filter(item => item.key !== 'template_attachments' && item.key !== '附件').map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: ele.unit, //字段单位
                        key: ele.key,
                        value: ele.value,
                        required: ele.required,
                        type: ele.extra && ele.extra.type ? ele.extra.type : '',
                        list: ele.extra && ele.extra.list ? ele.extra.list : []
                    }
                })
            return m
        })
        // console.log(customFieldsList.value);
    } else {
        customFieldsList.value = []
    }
    //自定义table
    const csTList = comfort_info.children.filter(item => item.extra && item.extra.myKey == '数据表')
    if (csTList.length) {
        customTableList.value = csTList.map(item => {
            let m = {
                name: item.name,
                name_en: item.name_en,
                tableHeader: [
                    i18n.global.t(item.extra.headerList[0]),
                    i18n.global.t(item.extra.headerList[1]),
                    i18n.global.t(item.extra.headerList[2]),
                ],
                headerList: item.extra.headerList,
                tableList: item.extra.tableList,
                showDelete: item.extra.showDelete
            }
            return m
        })
    } else {
        customTableList.value = []
    }
    //自定义table
    //自定义字段list底部  uukey不存在的 说明是底部的信息
    const csFList = comfort_info.children.filter(item => item.extra && item.show && (item.extra.myKey == '文本项' || item.extra.myKey == "文本项+附件项") && !item.extra.uukey)
    if (csFList.length) {
        customFieldsList1.value = csFList.map(item => {
            let m = {
                name: item.name,
                name_en: item.name_en,
                fieldsList: [],
                uukey: item.uukey,
                key: item.key
            }
            if (item.extra.myKey == '文本项') {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
            } else {
                m.showUpload = item.extra.showUpload
                m.showDelete = item.extra.showDelete
                m.id = item.extra.id
                m.accept = ""
                m.fileMaxSize = 1024 * 1024 * 200
                m.fileList = filterImglist(item.value, val.imageInfo)
                m.value = item.value
            }
            if (item.children)
                m.fieldsList = item.children.map(ele => {
                    return {
                        name: ele.name, //字段名称
                        name_en: ele.name_en, //字段名称
                        unit: ele.unit, //字段单位
                        key: ele.key,
                        value: ele.value,
                        required: ele.required,
                    }
                })
            return m
        })
    } else {
        customFieldsList1.value = []
    }
})

watch(() => customFieldsList.value.length + heatList.value.length + customTableList.value.length + customFieldsList1.value.length, (val) => {
    // 子信息为0 就隐藏当前tab
    if (val == 0) {
        // console.log(tabList);
        tabList.value[1].show = false;
        current_tab.value = 0
    } else {
        tabList.value[1].show = true;
    }
})

const FTTvalue = computed(() => {
    const target = customFieldsList.value.find(
        item => item.key === 'comfort_info_ftt'
    )
    return target?.fileList || []
})

watch(FTTvalue, (val) => {
    if (isInit.value) {
      isInit.value = false
      return
    }
    if ( val.length == 0) {
        // 清空 手感肤感的值
        emits('clearComfortInfoFtt')
    }
},{ deep: true })

/**文件上传部分 */
defineExpose({
    heatList,
    customFieldsList,
    customTableList,
    customFieldsList1,
    checkFileUpload,
    checkFileUpload1
})
</script>
<template>
    <!-- 热湿舒适度 -->
    <b-card v-for="(item, index) in heatList" :key="index"
        :style="route.query.type == 'view' ? { pointerEvents: 'none' } : {}">
        <div class="row gy-3 w-100">
            <div class="d-flex justify-content-between align-items-center pt-2 pb-2"
                style="border-bottom: 1px solid #E9EBEC; font-size: 16px;">
                {{ i18n.global.locale == 'en' ? item.name_en : item.name }}
            </div>
            <!-- 字段部分 -->
            <div class="row  d-flex ">
                <div style="flex:4">
                    <img :src="heatImg" style="height: 286px; object-fit: contain;" />
                </div>
                <div style="flex:6">
                    <div class="mt-4 mb-4">
                        {{ getLangValue("product-template.thermalComfortDat") }}
                    </div>
                    <!-- 上传框 -->
                    <div>
                        <DropZone :accept="item.accept" :title="getLangValue('upload.title')" :ipt-id="item.id"
                            @drop.prevent="drop($event, index)" @change.prevent="selectedFile(index)" style="min-height: 220px"
                            :info="getLangValue('upload.limit') + '50M'" />
                    </div>

                </div>
            </div>
            <!-- 预览 -->
            <div class=" border-solid rounded p-3" v-show="item.fileList && item.fileList.length">
                <div>
                    <div class="border-primary fs-14 material-title">{{ getLangValue("upload.uploadedFile") }}
                    </div>
                </div>
                <div class="product-img-slider  ps-5 pe-5">
                    <SwiperTool :swiperInfo="{
                        type: '',
                        page: 'assetform',
                        spaceBetween: 10,
                        slidesPerView: 15,
                        actionsClass: route.query.type != 'view' ? [
                            { name: 'ri-eye-fill', action: 'view' },
                            { name: 'ri-download-2-fill', action: 'download' },
                            { name: 'ri-delete-bin-5-fill', action: 'delete' },
                        ] : [
                            { name: 'ri-eye-fill', action: 'view' },
                            { name: 'ri-download-2-fill', action: 'download' },
                        ],
                    }" :list="item.fileList" @deleteFile="(...args) => deleteFile(...args, index)">
                    </SwiperTool>
                </div>
            </div>
        </div>
    </b-card>
    <!-- 字段图片上传部分 -->
    <customFieldCom :isCheckForm="isCheckForm" v-model:customFieldsList="customFieldsList" />
    <!-- 自定义表格部分 -->
    <!-- <customTableCom v-model:customTableList="customTableList" /> -->
    <!-- 自定义字段及上传 -->
    <customFieldCom :isCheckForm="isCheckForm" v-model:customFieldsList="customFieldsList1" />
</template>
<style scoped></style>
